import { render, staticRenderFns } from "./OverlayContainer.vue?vue&type=template&id=bad234de&scoped=true"
import script from "./OverlayContainer.vue?vue&type=script&lang=ts"
export * from "./OverlayContainer.vue?vue&type=script&lang=ts"
import style0 from "./OverlayContainer.vue?vue&type=style&index=0&id=bad234de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad234de",
  null
  
)

export default component.exports